export function formatoDisplay(value) {
  // console.log(value)
  // return;
  // console.log(value)
  // return 1;
  if (!value) return "";

  if (String(value).includes(".")) {
    value = String(value).replace(".", ",")
  }

  // Mantener solo números y coma
  value = String(value)?.replace(/[^\d,]/g, "");

  // Caso especial: si termina en coma ("1000,") → no tocar la parte entera
  if (/^\d+(,)?$/.test(value)) {
    const numeric = value.replace(",", "");
    const formatted = numeric.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return value.endsWith(",") ? formatted + "," : formatted;
  }

  // Caso normal: tiene parte decimal
  const [integerPart, decimalPart] = value.split(",");

  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

  return decimalPart !== undefined
    ? `${formattedInteger},${decimalPart}`
    : formattedInteger;
};

export const ID_TIPO_COMPROBANTE_BANCO = 10001;

export const esComprobanteBanco = (comprobante) =>
  comprobante?.id_tipo_comprobante === ID_TIPO_COMPROBANTE_BANCO;

export const armarNroComprobante = (comprobanteSelected, datosCabecera) => {
  const nro = datosCabecera?.comprobante_nro?.padStart(8, "0") ?? "";

  if (esComprobanteBanco(comprobanteSelected)) {
    const prefijo = String(datosCabecera?.id_banco ?? "").padStart(4, "0");
    return `${prefijo}-${nro}`;
  }

  const pv = datosCabecera?.comprobante_pv?.padStart(4, "0") ?? "";
  return `${pv}-${nro}`;
};

export function limpiarNumero(valor) {
  if (!valor) return 0;

  const numerico = String(valor)
    .replace(/\./g, "")
    .replace(",", ".");

  return parseFloat(numerico) || 0;
};

const formatoCalculo = (valor) => {
  return parseFloat(valor.replace(/\./g, "")?.replace(/,/g, "."));
};

const formatNumber = (value) => {
  if (!value) return "";

  value = value?.replace(/[^\d,]/g, "");

  if (/^\d+(,)?$/.test(value)) {
    const numeric = value.replace(",", "");
    const formatted = numeric.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return value.endsWith(",") ? formatted + "," : formatted;
  }

  const [integerPart, decimalPart] = value.split(",");
  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

  return decimalPart !== undefined
    ? `${formattedInteger},${decimalPart}`
    : formattedInteger;
};

const handleOnChangeTotal = (e, setTotal, setTotalMuestro) => {
  setTotal(
    parseFloat(
      e.target.value
        .replace(/\./g, "")  // borro ptos
        .replace(/,/g, ".")  // reermplazo comas x pto
    )
  );
  setTotalMuestro(formatNumber(e.target.value))
};